import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Info, X } from "lucide-react";
import api from "../lib/api";

// Prompt 20 — free-period heads-ups (dismissible, once per notice).
export default function NoticeBanners({ testid = "notice-banners" }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/billing/notices").then(({ data }) => setRows(data || [])).catch(() => {});
  }, []);
  const dismiss = async (type) => {
    await api.post(`/billing/notices/${type}/dismiss`).catch(() => {});
    setRows((r) => r.filter((n) => n.type !== type));
  };
  if (!rows.length) return null;
  return (
    <div className="space-y-3" data-testid={testid}>
      {rows.map((n) => (
        <div key={n.type} className="border border-amber-300 bg-amber-50 text-amber-900 p-4 text-sm flex gap-3"
             data-testid={`notice-${n.type}`}>
          <Info size={16} className="mt-0.5 shrink-0" />
          <div className="flex-1">
            <p data-testid={`notice-text-${n.type}`}>{n.text}</p>
            <div className="mt-2 flex gap-4">
              {n.show_add_card && (
                <Link to="/settings?tab=billing" className="underline font-medium"
                      data-testid={`notice-add-card-${n.type}`}>Add a card</Link>
              )}
              <Link to={n.help_url} className="underline" data-testid={`notice-help-${n.type}`}>Help</Link>
            </div>
          </div>
          <button type="button" onClick={() => dismiss(n.type)} aria-label="Dismiss"
                  data-testid={`notice-dismiss-${n.type}`}><X size={14} /></button>
        </div>
      ))}
    </div>
  );
}
